
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 10v1a1 1 0 001-1h-1zm0 4h1a1 1 0 00-1-1v1zm4 0v-1a1 1 0 00-1 1h1zm0-4h-1a1 1 0 001 1v-1zm-3-4V4a2 2 0 00-2 2h2zm0 4V6H9v4h2zm-5 1h4V9H6v2zm0 0V9a2 2 0 00-2 2h2zm0 2v-2H4v2h2zm0 0H4a2 2 0 002 2v-2zm4 0H6v2h4v-2zm1 5v-4H9v4h2zm0 0H9a2 2 0 002 2v-2zm2 0h-2v2h2v-2zm0 0v2a2 2 0 002-2h-2zm0-4v4h2v-4h-2zm5-1h-4v2h4v-2zm0 0v2a2 2 0 002-2h-2zm0-2v2h2v-2h-2zm0 0h2a2 2 0 00-2-2v2zm-4 0h4V9h-4v2zm-1-5v4h2V6h-2zm0 0h2a2 2 0 00-2-2v2zm-2 0h2V4h-2v2z","fill":"#BABABA"}})])
          )
        }
      }
    